
export class SelectedAccountsSettings {
	allowInstallments: boolean;
	allowRecurring: boolean;
	allowSingle: boolean;
	allowFuture: boolean;
	enableAutopay: boolean;
	installmentBalanceRanges: any;
	allowAch: boolean;
	allowCC: boolean;
	allowApplePay: boolean;
	minPayment: number;
	maxPayment: number;

	constructor() {
		this.allowFuture = true;
		this.allowInstallments = true;
		this.allowRecurring = true;
		this.allowSingle = true;
		this.enableAutopay = true;
		this.installmentBalanceRanges = {};
		this.allowAch = true;
		this.allowCC = true;
		this.allowApplePay = true;
	}
}
